import { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation } from "react-router-dom";
import Lottie from 'lottie-react';
import bgMobile from '../images/background-mobile.jpg';
import bgDesktop from '../images/background-desktop.jpg';
import swirlAnim from '../animations/swirling-wine.json';

const isDesktop = () => window.matchMedia('(min-width: 600px)').matches;

const Layout = () => {
  const bg = isDesktop() ? bgDesktop : bgMobile;
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);
  const isFirstMount = useRef(true);

  // Initial mount: show then hide after 700ms
  useEffect(() => {
    const t = setTimeout(() => {
      setFading(true);
      setTimeout(() => setVisible(false), 500);
    }, 700);
    return () => clearTimeout(t);
  }, []);

  // Route change: show overlay briefly
  useEffect(() => {
    if (isFirstMount.current) { isFirstMount.current = false; return; }

    // Reset iOS viewport zoom (triggered by <16px inputs on previous page)
    const meta = document.querySelector('meta[name=viewport]');
    if (meta) {
      const orig = meta.content;
      meta.content = orig + ', maximum-scale=1';
      requestAnimationFrame(() => { meta.content = orig; });
    }

    setFading(false);
    setVisible(true);
    const t = setTimeout(() => {
      setFading(true);
      setTimeout(() => setVisible(false), 500);
    }, 700);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <>
      <div className="global-bg" style={{ backgroundImage: `url(${bg})` }} />
      {visible && (
        <div className={`gl-loader${fading ? ' gl-loader-out' : ''}`}>
          <Lottie animationData={swirlAnim} loop className="gl-loader-anim" />
        </div>
      )}
      <Outlet />
    </>
  );
};

export default Layout;
